import { call, put, takeEvery } from "redux-saga/effects";

import {
    GET_DEFAULT_GCP_THRESHOLD_BY_RESOURCE_ID,
    GET_GCP_ALERTS,
    GET_GCP_MISSING_ALERTS_BY_RESOURCE_ID,
    GET_GCP_RESOURCE_BY_RESOURCE_ID,
    POST_DISABLE_GCP_ALERTS,
    POST_ENABLE_GCP_ALERTS,
    PUT_GCP_ALERTS,
    POST_SPECIFIC_GCP_RESOURCE_SERVICE_MAPPING,
    POST_SPECIFIC_GCP_CREATE_RESOURCE_ALERTS,
} from "./actionTypes";

import {
    getGCPAlertsFail,
    getGCPAlertsSuccess,
    getGCPResourceByResourceIDSuccess,
    getGCPResourceByResourceIDFail,
    getDefaultGCPThresholdByMonitoredResourceIDSuccess,
    getDefaultGCPThresholdByMonitoredResourceIDFail,
    getMissingGCPAlertsByResourceIDSuccess,
    getMissingGCPAlertsByResourceIDFail,
    postEnableGCPAlertsFail,
    postEnableGCPAlertsSuccess,
    postDisableGCPAlertsFail,
    postDisableGCPAlertsSuccess,
    putGCPAlertsSuccess,
    putGCPAlertsFail,
    postSpecificGCPResourceServiceMappingFail,
    postSpecificGCPResourceServiceMappingSuccess,
    postSpecificGCPCreateResourceAlertsSuccess,
    postSpecificGCPCreateResourceAlertsFail,
} from "./actions";

import {
    getGCPAlertsUrl,
    getGCPResourceByIDUrl,
    getDefaultGCPThresholdByMonitoredResourceIDUrl,
    getGCPMissingAlertsByResourceIDUrl,
    postDisableGCPAlertUrl,
    postEnableGCPAlertUrl,
    putUpdateGCPAlertUrl,
    postGCPServiceMapping,
    postCreateGcpResourceAlertsUrl
} from "../../helpers/fakebackend_helper";
import { showNotification } from "components/Common/notification";

function* onGetGCPMissingAlertsByResourceID(resource_id) {
    try {
        const response = yield call(getGCPMissingAlertsByResourceIDUrl, resource_id.payload);
        yield put(getMissingGCPAlertsByResourceIDSuccess(response));
    } catch (error) {
        yield put(getMissingGCPAlertsByResourceIDFail(error.message));
    }
}

function* onGetGCPAlerts(monitored_resource_id) {
    try {
        const response = yield call(getGCPAlertsUrl, monitored_resource_id.payload);
        let final_response = {}
        final_response[monitored_resource_id.payload] = response;
        yield put(getGCPAlertsSuccess(final_response));
    } catch (error) {
        yield put(getGCPAlertsFail(error));
    }
}

function* onGetGCPResourceByID(resource_id) {
    try {
        const response = yield call(getGCPResourceByIDUrl, resource_id.payload);
        yield put(getGCPResourceByResourceIDSuccess(response));
    } catch (error) {
        yield put(getGCPResourceByResourceIDFail(error.message));
    }
}

function* onGetDefaultGCPThresholdMissingAlertsByResourceID(resource_id) {
    try {
        const response = yield call(getDefaultGCPThresholdByMonitoredResourceIDUrl, resource_id.payload);
        yield put(getDefaultGCPThresholdByMonitoredResourceIDSuccess(response));
    } catch (error) {
        yield put(getDefaultGCPThresholdByMonitoredResourceIDFail(error.message));
    }
}

function* onPostDisableGCPAlerts({ payload: { data } }) {
    try {
        const response = yield call(postDisableGCPAlertUrl, data);
        yield put(postDisableGCPAlertsSuccess(response));
        if (response) {
            showNotification("success", "Disabled the GCP Alerts successfully!");
        }
        window.location.reload()
    } catch (error) {
        yield put(postDisableGCPAlertsFail(error));
        if (error) {
            showNotification("error", "Failed to disable the GCP Alerts");
        }
    }
}

function* onPostEnableGCPAlerts({ payload: { data } }) {
    try {
        const response = yield call(postEnableGCPAlertUrl, data)
        yield put(postEnableGCPAlertsSuccess(response));
        if (response) {
            showNotification("success", "Enabled the GCP Alerts successfully!");
        }
        window.location.reload()
    } catch (error) {
        yield put(postEnableGCPAlertsFail(error));
        if (error) {
            showNotification("error", "Failed to enable the GCP Alerts");
        }
    }
}

function* onPutUpdateGCPAlerts({ payload: { data } }) {
    try {
        const response = yield call(putUpdateGCPAlertUrl, data);
        yield put(putGCPAlertsSuccess(response));

        if (response) {
            showNotification("success", "Updated GCP Alert successfully!");
        }
        window.location.reload()
    } catch (error) {
        yield put(putGCPAlertsFail(error.message));
        if (error) {
            showNotification("error", "Failed to update GCP Alert");
        }
    }
}

function* onPostResourceServiceMapping({ payload: { data } }) {
    try {
        const response = yield call(postGCPServiceMapping, data);
        yield put(postSpecificGCPResourceServiceMappingSuccess(response));
        if (response) {
            showNotification("success", "Service Mapping updated successfully!");
        }
        window.location.reload()
    } catch (error) {
        yield put(postSpecificGCPResourceServiceMappingFail(error.message));
        if (error) {
            showNotification("error", "Failed to update");
        }
    }
}

function* onPostSpecificGCPCreateResourceAlerts({ payload: { data } }) {
    try {
        const response = yield call(postCreateGcpResourceAlertsUrl, data);
        yield put(postSpecificGCPCreateResourceAlertsSuccess(response));
        if (response) {
            showNotification("success", "Alerts are deployed successfully!");
        }
        window.location.reload()
    } catch (error) {
        yield put(postSpecificGCPCreateResourceAlertsFail(error));
        if (error.response.data.message === "Plan has expired") {
            showNotification("error", "Your subscription has expired. Please renew!");
        }
    }
}

function* GCPAlertsSaga() {
    yield takeEvery(GET_GCP_ALERTS, onGetGCPAlerts);
    yield takeEvery(GET_GCP_RESOURCE_BY_RESOURCE_ID, onGetGCPResourceByID);
    yield takeEvery(GET_DEFAULT_GCP_THRESHOLD_BY_RESOURCE_ID, onGetDefaultGCPThresholdMissingAlertsByResourceID);
    yield takeEvery(GET_GCP_MISSING_ALERTS_BY_RESOURCE_ID, onGetGCPMissingAlertsByResourceID);
    yield takeEvery(POST_ENABLE_GCP_ALERTS, onPostEnableGCPAlerts);
    yield takeEvery(POST_DISABLE_GCP_ALERTS, onPostDisableGCPAlerts);
    yield takeEvery(PUT_GCP_ALERTS, onPutUpdateGCPAlerts);
    yield takeEvery(POST_SPECIFIC_GCP_RESOURCE_SERVICE_MAPPING, onPostResourceServiceMapping);
    yield takeEvery(POST_SPECIFIC_GCP_CREATE_RESOURCE_ALERTS, onPostSpecificGCPCreateResourceAlerts);
}

export default GCPAlertsSaga;
